"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dsWeb = require("@olxbr/ds-web");
var _ModalContent = _interopRequireDefault(require("./components/ModalContent"));
var _propTypes = require("prop-types");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ModalImage = function ModalImage(_ref) {
  var isLandscape = _ref.isLandscape,
    _ref$openModal = _ref.openModal,
    openModal = _ref$openModal === void 0 ? false : _ref$openModal,
    imageWebp = _ref.imageWebp,
    image = _ref.image,
    alt = _ref.alt,
    handleCloseModal = _ref.handleCloseModal;
  var closeModal = function closeModal() {
    handleCloseModal();
  };
  return openModal ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Modal, {
    size: isLandscape ? 'large' : 'small',
    open: openModal,
    maxWidth: '100%',
    maxHeight: '100%',
    closeCallback: closeModal,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalContent["default"], {
      isLandscape: isLandscape,
      imageWebp: imageWebp,
      image: image,
      alt: alt
    })
  }) : null;
};
ModalImage.prototype = {
  isLandscape: _propTypes.bool.isRequired,
  openModal: _propTypes.bool.isRequired,
  imageWebp: _propTypes.string.isRequired,
  image: _propTypes.string.isRequired,
  alt: _propTypes.string.isRequired,
  handleCloseModal: _propTypes.func.isRequired
};
var _default = exports["default"] = ModalImage;